export default __webpack_public_path__ + "media/images/features/toyono/sub_title_left-0fb085cf2980d409cd524fcb4dc2b496.png";